import React, { useState } from 'react';
import {
    GlobalContainer,
    ContentContainer,
    ReportContainer,
    TitleContainer,
    Title,
    IntervalTitle
} from '../styles';
import AlertIcon from '../../assets/alert_icon2.png';
import { formatDate, rowspan, today } from '../../utils';
import ReportInputDataInterval from '../../Components/ReportInputDataInterval'
import ModalWarn from '../../Components/Modal/Warn/index'

export default function ManagersByAgencyAdminReport(props) {
    const [dataInterval, setDataInterval] = useState({ dt_inicio: "", dt_fim: today() });
    const [loadingReport, setLoadingReport] = useState(false);
    const [result, setResult] = useState();
    const [searchErro, setSearchErro] = useState(false);
    const [searchErroMessage, setSearchErroMessage] = useState("");
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    const onSubmitSearch = async () => {
        setLoadingReport(true);
        setSearchErro(false);

        const user = JSON.parse(localStorage.getItem('user'));
        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': user ? user.token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: user ? user.cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está gerando o relatório
                dt_inicio: dataInterval.dt_inicio,
                dt_fim: dataInterval.dt_fim
            }),
        };

        await fetch(`${process.env.REACT_APP_API_URL}/gestao/relGestoresPorOrgao`, requestOptions).then(
            function (response) {
                if (response.ok) {
                    response.json().then(function (data) {
                        setResult(rowspan.setTd(data, 'NOME_REDE_ATENDIMENTO'));
                    });
                } else if (response.status === 422) {
                    response.json().then(function (data) {
                        setSearchErro(true);
                        if (!!data.errorCode && !!data.messages) {
                            setSearchErroMessage(data.messages[0].message);
                        } else if (!!data.errorCode && !!data.message) {
                            setSearchErroMessage(data.message);
                        } else {
                            setSearchErroMessage('Houve algum problema no servidor.');
                        }
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setModalInvalidSessionError(true)
                    })
                } else if (response.status === 400) {
                    response.json().then(function (data) {
                        if (!!data.errorCode && !!data.messages) {
                            setSearchErro(true);
                            setSearchErroMessage(data.messages[0].message);
                        } else {
                            setSearchErro(true);
                            setSearchErroMessage('Houve algum problema no servidor.');
                        }
                    });
                } else {
                    setSearchErro(true);
                    setSearchErroMessage('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                }
            }).catch(function (err) {
                console.error('Failed retrieving information', err);
            });

        setLoadingReport(false);
    }
    return (
        <GlobalContainer>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <ContentContainer>
                <TitleContainer>
                    <Title>Número de Gestores por rede de atendimento</Title>
                </TitleContainer>
                <ReportInputDataInterval
                    onSubmitSearch={onSubmitSearch}
                    dataInterval={dataInterval}
                    setDataInterval={setDataInterval}
                    loadingReport={loadingReport}
                    setResult={setResult}
                    result={result}
                    modalError={searchErro}
                    setModalError={setSearchErro}
                    messageError={searchErroMessage}
                    history={props.history}
                />
                {result?.length > 0 ?
                    <ReportContainer>
                        <IntervalTitle>
                            {dataInterval.dt_inicio && dataInterval.dt_fim &&
                                <label>Período: de {formatDate(dataInterval.dt_inicio)} à {formatDate(dataInterval.dt_fim)}</label>
                            }
                            {dataInterval.dt_inicio && !dataInterval.dt_fim &&
                                <label>Período: de {formatDate(dataInterval.dt_inicio)} à {formatDate(today())}</label>
                            }
                            {!dataInterval.dt_inicio && (dataInterval.dt_fim && formatDate(dataInterval.dt_fim) !== formatDate(today())) &&
                                <label>Período: até {formatDate(dataInterval.dt_fim)} </label>
                            }
                        </IntervalTitle>
                        <div className="br-table" data-search="data-search" data-selection="data-selection">
                            <table>
                                <thead>
                                    <tr>
                                        <th> Rede de atendimento </th>
                                        <th> Perfil </th>
                                        <th> Quantidade de gestores ativos </th>
                                        <th> Quantidade de gestores cancelados </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result.map((r, i) => (
                                        <tr key={i}>
                                            {rowspan.td(r, r.NOME_REDE_ATENDIMENTO)}
                                            <td style={{ 'padding-left': 'calc(var(--table-padding)*0.5)'}}>{r.PERFIL}</td>
                                            <td>{r.QTDE_GESTORES_ATIVOS || 0}</td>
                                            <td>{r.QTDE_GESTORES_CANCELADOS || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </ReportContainer>
                    :
                    <>
                        {result?.length === 0 &&
                            <span className="feedback warning" role="alert" id="listresult">
                                <i className="fas fa-times-circle" aria-hidden="true">
                                    <img
                                        src={AlertIcon}
                                        style={{ paddingBottom: '5px' }}
                                        alt="failicon"
                                    />
                                </i>
                                <label id="listresultlabel">Nenhum registro encontrado para os parâmetros informados.</label>
                            </span>
                        }
                    </>
                }
            </ContentContainer>
        </GlobalContainer>
    );
}